// extracted by mini-css-extract-plugin
export default {"root":"ItemHeader_root__FMUQG","title":"ItemHeader_title__0oht+"};